import { DateTime } from "luxon";
import type { SharedApiV2 } from "@capstone/mock-api";
import { Site } from "src/app/core/sites";
import { Brand, getApiDetailsDecorator, parseDateTime } from "src/utils";
import { HelpAssistUser } from "./help-assist-user.model";
import { HelpAssistTicketReference } from "./models/ticket/base-help-assist-ticket.model";

const api = getApiDetailsDecorator<SharedApiV2.TicketAttachmentDto>();
type ApiModel = SharedApiV2.TicketAttachmentDto;

export class Attachment {
  private constructor(args: ClassProperties<Attachment>) {
    this.blobUrl = args.blobUrl;
    this.created = args.created;
    this.fileName = args.fileName;
    this.id = args.id;
    this.site = args.site;
    this.ticket = args.ticket;
  }

  public readonly created: Change;
  @api() public readonly blobUrl: string;
  @api() public readonly fileName: string;
  @api() public readonly id: Brand<number, "attachment">;
  public readonly site: Site;
  @api({ key: "ticketId" }) public readonly ticket: HelpAssistTicketReference;

  public static deserialize(
    apiModel: ApiModel,
    { site }: DeserializeArguments,
  ): Attachment {
    return new Attachment({
      blobUrl: apiModel.blobUrl,
      created: {
        byUser: HelpAssistUser.deserialize(apiModel.createdByUser),
        on: parseDateTime(apiModel.createdOn),
      },
      fileName: apiModel.fileName,
      id: apiModel.id,
      site,
      ticket: { id: apiModel.ticketId, site },
    });
  }

  public static deserializeList(
    value: readonly ApiModel[],
    args: DeserializeArguments,
  ): Attachment[] {
    return value.map((ticket) => Attachment.deserialize(ticket, args));
  }
}

interface DeserializeArguments {
  readonly site: Site;
}

interface Change {
  readonly on: DateTime;
  readonly byUser: HelpAssistUser;
}
